import { AppState } from 'src/store/app/types';
import { PayloadAction } from '@reduxjs/toolkit';

const setAppIsMobileReducer = (state: AppState, action: PayloadAction<boolean>) => {
  state.isMobile = action.payload;
};

export default setAppIsMobileReducer;
